module.exports = __webpack_public_path__ + "img/bg_login.d6b1b0f8.png";